@if (loading) {
  <app-loader></app-loader>
}

<div class="chain-wrap">
  <div class="chain">
    <div class="chain-info chain-item">
      <div class="chain-info-domain">{{info.name}}</div>
      <div class="chain-info-date">{{info.date}}</div>
      <div class="chain-info-system">{{info.system}}</div>
    </div>

    @for (circle of circles; track circle; let first = $first; let last = $last; let index = $index) {
      <div class="chain-circles">
        @if (first && !StartWithBreakLine) {
          <div class="chain-item chain-arrow-start">
            <div class="chain-arrow">
              <div class="end-arrow"></div>
            </div>
          </div>
        }
        @if (first && StartWithBreakLine) {
          <div class="chain-item chain-item-arrows-start-long">
            <div class="chain-arrow">
              <div class="end-arrow"></div>
              <div class="break-arrows">
                <div class="break-arrow"></div>
                <div class="break-arrow"></div>
                <div class="break-arrow"></div>
              </div>
            </div>
          </div>
        }
        <div class="chain-item chain-circle">
          <div class="chain-circle-top-info">
            <div class="chain-circle-top-session">{{circle?.session_source}}</div>
            <div class="chain-circle-top-date">{{circle?.event_date}}</div>
          </div>
          <div class="chain-item-circle">
            <img [class.default-img]="circle.imgsrc === defaultImagePath" src="{{circle.imgsrc}}" />
          </div>
          <div class="chain-item-goalname">{{circle?.goalname}}</div>
        </div>
        @if (!last) {
          <div class="chain-item-arrows-{{circle.formatted.arrowType}}">
            <div class="full-arrow">
              <div class="arrow-{{circle.formatted.arrowType}}">
                <div class="chain-arrow">
                  <div class="start-arrow"></div>
                  @if (circle.formatted.arrowType==='longer') {
                    <div class="break-arrows">
                      <div class="break-arrow"></div>
                      <div class="break-arrow"></div>
                      <div class="break-arrow"></div>
                    </div>
                  }
                </div>
              </div>
              <div class="arrow-separator"></div>
              <div class="arrow-{{circle.formatted.arrowType}}">
                <div class="chain-arrow">
                  <div class="end-arrow"></div>
                  @if (circle.formatted.arrowType==='longer') {
                    <div class="break-arrows">
                      <div class="break-arrow"></div>
                      <div class="break-arrow"></div>
                      <div class="break-arrow"></div>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="chain-period-info">
              <div class="chain-period-info-duration">{{circles[index+1].duration_day}}</div>
              @if (showPeriodSessionInfo) {
                <div class="chain-period-info-session">{{circles[index+1].formatted.session}}
                </div>
              }
              @if (showPeriodSessionInfo) {
                <div class="chain-period-info-pages">{{circles[index+1].formatted.pages}}</div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>